import React, { memo, useState } from 'react'
import { Popover, Checkbox } from '@mantine/core'
import { Global, css } from '@emotion/react'
import { FilterIcon } from '@ow/icons'
import { Button } from '@ow/comps'
import { useTheme } from '@ow/theme'

const Filter = ({ name, options = [], onChange }) => {
  const [opened, setOpened] = useState(false)
  const [value, setValue] = useState([])
  const { themeClass } = useTheme()
  return (
    <>
      <Global
        styles={css`
          .mantine-CheckboxGroup-root {
            .mantine-Group-root {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }
            .mantine-Checkbox-label {
              font-weight: 400;
            }
          }
          .mantine-Popover-dropdown {
            padding: 0;
          }
        `}
      />
      <Popover
        opened={opened}
        onClose={() => setOpened(false)}
        zIndex={1000}
        position="bottom"
        withArrow
      >
        <Popover.Target>
          <span className="cursor-pointer" onClick={() => setOpened((o) => !o)}>
            <FilterIcon width={16} height={16} fill="#0152D9" />
          </span>
        </Popover.Target>
        <Popover.Dropdown>
          <div className={themeClass}>
            <div className="overflow-auto" style={{ maxHeight: 300 }}>
              <div className="p-4">
                <Checkbox.Group value={value} onChange={setValue}>
                  {options.map((o) => {
                    if (typeof o === 'string') {
                      return <Checkbox key={o} value={o} label={o} />
                    }
                    return (
                      <Checkbox key={o.value} value={o.value} label={o.label} />
                    )
                  })}
                </Checkbox.Group>
              </div>
            </div>
            <div className="flex gap-2 p-4 border-t">
              <Button size="sm" stroke onClick={() => setOpened(false)}>
                取消
              </Button>
              <Button
                size="sm"
                type="primary"
                onClick={() => {
                  if (onChange) onChange(value, name)
                  setOpened(false)
                }}
              >
                确定
              </Button>
            </div>
          </div>
        </Popover.Dropdown>
      </Popover>
    </>
  )
}

export default memo(Filter)
